/* eslint-disable i18next/no-literal-string -- css not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const field = defineSlotRecipe({
  className: 'chakra-field',
  slots: ['root', 'label', 'errorText', 'helperText', 'requiredIndicator'],
  base: {
    requiredIndicator: {
      color: 'fg.error',
      lineHeight: '1',
    },
    root: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      gap: '1',
    },
    label: {
      fontWeight: 'normal',
      mb: 1,
      color: 'fg.muted',
      fontSize: 'sm',
      marginBottom: 0,
    },
    errorText: {
      fontWeight: 'normal',
      color: 'fg.error',
      fontSize: 'xs',
    },
    helperText: {
      color: 'fg.muted',
      fontWeight: 'normal',
      mb: 1,
      fontSize: 'xs',
    },
  },
});
